type Permission = string;
type Permissions = Permission[];

export class AccessControl {
  private _permissions: Permissions;

  constructor(permissions: Permissions) {
    this._permissions = permissions;
  }

  hasAccess(permission: Permission): boolean {
    return this._permissions.includes(permission);
  }

  canSendMoney() {
    return this.hasAccess("money_transfer__send");
  }

  shownTeasersList() {
    return this.hasAccess("shown_teasers__list");
  }

  shouldShownTaxonomy() {
    return this.hasAccess("ad_common__target_taxonomy");
  }

  shouldShownAudiences() {
    return this.hasAccess("ad_common__target_audiences");
  }

  shouldShownSocdem() {
    return this.hasAccess("ad_common__target_socdem");
  }
}
